import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { getUrlWithVersion } from '../../../../api/api'

export const quickAccessAddProduct = createAsyncThunk<
    { guid: string },
    { guid: string },
    ThunkConfig<string>
>('productsSlice/quickAccessAddProduct', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid } = arg

    try {
        await api.post<string[]>(
            getUrlWithVersion(`/users/current/quick_access`),
            { guid }
        )
        throwSuccessMessage('Product added to quick access!')
        return { guid }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to add quick access product')
    }
})
